import { useTranslation } from "react-i18next";
import PageHero from "@/components/layout/PageHero";

const AboutContent = () => {
  const { t } = useTranslation('about');
  const offerItems = [
    {
      title: t('whatWeOffer.verified.title'),
      description: t('whatWeOffer.verified.description'),
    },
    {
      title: t('whatWeOffer.directContact.title'),
      description: t('whatWeOffer.directContact.description'),
    },
    {
      title: t('whatWeOffer.reviews.title'),
      description: t('whatWeOffer.reviews.description'),
    },
  ];
  const whyChooseItems = [
    {
      title: t('whyChoose.local.title'),
      description: t('whyChoose.local.description'),
    },
    {
      title: t('whyChoose.expat.title'),
      description: t('whyChoose.expat.description'),
    },
    {
      title: t('whyChoose.transparent.title'),
      description: t('whyChoose.transparent.description'),
    },
  ];

  return (
    <div className="bg-brand-mist">
      <PageHero
        title={t('title')}
        description={t('subtitle')}
        contentClassName="py-12 md:py-16"
      />

      <section className="border-b border-brand-cloud bg-white px-4 py-14 md:py-20">
        <div className="mx-auto grid max-w-6xl gap-8 lg:grid-cols-[minmax(0,0.33fr)_minmax(0,0.67fr)] lg:gap-14">
          <h2 className="public-section-title">{t('mission.title')}</h2>
          <p className="public-body">
            {t('mission.description')}
          </p>
        </div>
      </section>

      <section className="px-4 py-14 md:py-20">
        <div className="mx-auto max-w-6xl">
          <h2 className="public-section-title">{t('whatWeOffer.title')}</h2>
          <div className="mt-10 grid gap-6 md:grid-cols-3">
            {offerItems.map((item, index) => (
              <article key={item.title} className="border-t border-brand-cloud pt-6">
                <p className="text-sm font-medium text-brand-slate">0{index + 1}</p>
                <h3 className="mt-4 public-card-title">{item.title}</h3>
                <p className="mt-3 public-small">{item.description}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="border-y border-brand-cloud bg-white px-4 py-14 md:py-20">
        <div className="mx-auto grid max-w-6xl gap-10 lg:grid-cols-[minmax(0,0.33fr)_minmax(0,0.67fr)] lg:gap-14">
          <div>
            <h2 className="public-section-title">{t('whyChoose.title')}</h2>
          </div>

          <div className="divide-y divide-brand-cloud">
            {whyChooseItems.map((item) => (
              <article key={item.title} className="grid gap-3 py-6 first:pt-0 last:pb-0 md:grid-cols-[minmax(0,0.38fr)_minmax(0,0.62fr)] md:gap-8">
                <h3 className="public-card-title">{item.title}</h3>
                <p className="public-small">{item.description}</p>
              </article>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutContent;
